export default "__VITE_ASSET__BJRrSaEG__"